import React from 'react';
import {Link} from 'react-router-dom'
import "./MainButton.scss"

export default function MainButton({title, link}){
  return (
    <>
      <Link to={link} className="btn">
        <span>{title}</span>
      </Link>
    </>
  );
};
